module.exports = __webpack_public_path__ + "img/banner.891af72a.png";